import React from "react";
import CssSvg from "../../../images/svg/css-3.inline.svg";
import D3Svg from "../../../images/svg/d3-2.inline.svg";
import JsSvg from "../../../images/svg/javascript.inline.svg";
import DjangoSvg from "../../../images/svg/django.inline.svg";
import FirebaseSvg from "../../../images/svg/firebase.inline.svg";
import Html5Svg from "../../../images/svg/html5.inline.svg";
import NodejsSvg from "../../../images/svg/nodejs-icon.inline.svg";
import PythonSvg from "../../../images/svg/python-4.inline.svg";
import ReactSvg from "../../../images/svg/react.inline.svg";
import ExpressSvg from "../../../images/svg/express.inline.svg";
import ReduxSvg from "../../../images/svg/redux.inline.svg";
import GolangSvg from "../../../images/svg/golang.inline.svg";

const classes = require("./Card.module.scss");

const Card = (props: {
    title: string;
    description: string;
    link: string;
    techUsed: Array<any>;
}) => {
    var techStack = props.techUsed.map(technology => {
        switch (technology) {
            case "HTML":
                return <Html5Svg className={classes.svgSizer} />;

            case "React" || "React-Native":
                return <ReactSvg className={classes.svgSizer} />;

            case "CSS":
                return <CssSvg className={classes.svgSizer} />;

            case "NodeJS":
                return <NodejsSvg className={classes.svgSizer} />;

            case "Django":
                return <DjangoSvg className={classes.svgSizer} />;

            case "Python":
                return <PythonSvg className={classes.svgSizer} />;

            case "Redux":
                return <ReduxSvg className={classes.svgSizer} />;

            case "ExpressJS":
                return <ExpressSvg className={classes.svgSizer} />;

            case "D3":
                return <D3Svg className={classes.svgSizer} />;

            case "Javascript":
                return <JsSvg className={classes.svgSizer} />;

            case "Firebase":
                return <FirebaseSvg className={classes.svgSizer} />;

            case "GoLang":
                return <GolangSvg className={classes.svgSizer} />;

            default:
                return null;
        }
    });

    return (
        <div className={classes.card}>
            <h2 className={classes.cardHeading}>
                <a href={props.link}>{props.title}</a>
                <hr />
            </h2>
            <p>{props.description}</p>
            <div>{techStack}</div>
        </div>
    );
};

export default Card;
